import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  // Arka plan kaymasını KESİN olarak engellemek için
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add('no-scroll-mobile');
    } else {
      document.body.classList.remove('no-scroll-mobile');
    }
    // Component unmount olursa (sayfa değişimi vb.) sınıfı temizle
    return () => {
      document.body.classList.remove('no-scroll-mobile');
    };
  }, [isMobileMenuOpen]);

  const toggleDropdown = (menuName) => {
    if (activeDropdown === menuName) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(menuName);
    }
  };

  const closeAllMenus = () => {
    setIsMobileMenuOpen(false);
    setActiveDropdown(null);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        
        {/* SOL TARAF: LOGO */}
        <div className="nav-logo-wrapper">
          <Link to="/" onClick={closeAllMenus}>
            <img src="/logo.png" alt="Ankara Merkez Teknik" className="nav-logo-img" />
          </Link>
        </div>

        {/* MOBİL İÇİN TAM ORTA YAZI */}
        <div className="nav-mobile-title">
          ANKARA MERKEZ TEKNİK
        </div>

        {/* TAM EKRAN AÇILAN MOBİL MENÜ KAPSAYICISI */}
        <ul className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
          <li><Link to="/" onClick={closeAllMenus}>Ana Sayfa</Link></li>
          <li><Link to="/hakkimizda" onClick={closeAllMenus}>Hakkımızda</Link></li>
          
          <li className={`dropdown ${activeDropdown === 'hizmetler' ? 'active' : ''}`}>
            <span className="dropbtn" onClick={() => toggleDropdown('hizmetler')}>
              Hizmetlerimiz {activeDropdown === 'hizmetler' ? '▴' : '▾'}
            </span>
            <div className="dropdown-content mega-menu">
              <Link to="/hizmet/kombi-servisi" onClick={closeAllMenus}>▸ Kombi Teknik Servis</Link>
              <Link to="/hizmet/klima-servisi" onClick={closeAllMenus}>▸ Klima Teknik Servis</Link>
              <Link to="/hizmet/camasir-makinesi-servisi" onClick={closeAllMenus}>▸ Çamaşır Makinesi Servis</Link>
              <Link to="/hizmet/bulasik-makinesi-servisi" onClick={closeAllMenus}>▸ Bulaşık Makinesi Servis</Link>
              <Link to="/hizmet/buzdolabi-servisi" onClick={closeAllMenus}>▸ Buzdolabı Teknik Servis</Link>
            </div>
          </li>
          
          {/* BEYAZ EŞYA MARKALARI - FULL LİSTE */}
          <li className={`dropdown ${activeDropdown === 'beyazesya' ? 'active' : ''}`}>
            <span className="dropbtn" onClick={() => toggleDropdown('beyazesya')}>
              Beyaz Eşya Markaları {activeDropdown === 'beyazesya' ? '▴' : '▾'}
            </span>
            <div className="dropdown-content mega-menu">
              <Link to="/marka/arcelik-beyaz-esya" onClick={closeAllMenus}>▸ Arçelik</Link>
              <Link to="/marka/beko-beyaz-esya" onClick={closeAllMenus}>▸ Beko</Link>
              <Link to="/marka/bosch-beyaz-esya" onClick={closeAllMenus}>▸ Bosch</Link>
              <Link to="/marka/siemens-beyaz-esya" onClick={closeAllMenus}>▸ Siemens</Link>
              <Link to="/marka/vestel-beyaz-esya" onClick={closeAllMenus}>▸ Vestel</Link>
              <Link to="/marka/samsung-beyaz-esya" onClick={closeAllMenus}>▸ Samsung</Link>
              <Link to="/marka/lg-beyaz-esya" onClick={closeAllMenus}>▸ LG</Link>
              <Link to="/marka/profilo-beyaz-esya" onClick={closeAllMenus}>▸ Profilo</Link>
              <Link to="/marka/electrolux-beyaz-esya" onClick={closeAllMenus}>▸ Electrolux</Link>
              <Link to="/marka/aeg-beyaz-esya" onClick={closeAllMenus}>▸ AEG</Link>
              <Link to="/marka/whirlpool-beyaz-esya" onClick={closeAllMenus}>▸ Whirlpool</Link>
              <Link to="/marka/indesit-beyaz-esya" onClick={closeAllMenus}>▸ Indesit</Link>
              <Link to="/marka/hotpoint-beyaz-esya" onClick={closeAllMenus}>▸ Hotpoint</Link>
              <Link to="/marka/miele-beyaz-esya" onClick={closeAllMenus}>▸ Miele</Link>
              <Link to="/marka/grundig-beyaz-esya" onClick={closeAllMenus}>▸ Grundig</Link>
              <Link to="/marka/altus-beyaz-esya" onClick={closeAllMenus}>▸ Altus</Link>
              <Link to="/marka/regal-beyaz-esya" onClick={closeAllMenus}>▸ Regal</Link>
              <Link to="/marka/seg-beyaz-esya" onClick={closeAllMenus}>▸ Seg</Link>
            </div>
          </li>

          {/* KOMBİ MARKALARI - FULL LİSTE */}
          <li className={`dropdown ${activeDropdown === 'kombi' ? 'active' : ''}`}>
            <span className="dropbtn" onClick={() => toggleDropdown('kombi')}>
              Kombi Markaları {activeDropdown === 'kombi' ? '▴' : '▾'}
            </span>
            <div className="dropdown-content mega-menu">
              <Link to="/marka/vaillant-kombi" onClick={closeAllMenus}>▸ Vaillant</Link>
              <Link to="/marka/viessmann-kombi" onClick={closeAllMenus}>▸ Viessmann</Link>
              <Link to="/marka/buderus-kombi" onClick={closeAllMenus}>▸ Buderus</Link>
              <Link to="/marka/bosch-kombi" onClick={closeAllMenus}>▸ Bosch</Link>
              <Link to="/marka/demirdokum-kombi" onClick={closeAllMenus}>▸ Demirdöküm</Link>
              <Link to="/marka/baymak-kombi" onClick={closeAllMenus}>▸ Baymak</Link>
              <Link to="/marka/eca-kombi" onClick={closeAllMenus}>▸ E.C.A.</Link>
              <Link to="/marka/alarko-kombi" onClick={closeAllMenus}>▸ Alarko Carrier</Link>
              <Link to="/marka/protherm-kombi" onClick={closeAllMenus}>▸ Protherm</Link>
              <Link to="/marka/ariston-kombi" onClick={closeAllMenus}>▸ Ariston</Link>
              <Link to="/marka/ferroli-kombi" onClick={closeAllMenus}>▸ Ferroli</Link>
              <Link to="/marka/daikin-kombi" onClick={closeAllMenus}>▸ Daikin</Link>
              <Link to="/marka/immergas-kombi" onClick={closeAllMenus}>▸ Immergas</Link>
              <Link to="/marka/warmhaus-kombi" onClick={closeAllMenus}>▸ Warmhaus</Link>
              <Link to="/marka/termoteknik-kombi" onClick={closeAllMenus}>▸ Termoteknik</Link>
              <Link to="/marka/airfel-kombi" onClick={closeAllMenus}>▸ Airfel</Link>
              <Link to="/marka/arcelik-kombi" onClick={closeAllMenus}>▸ Arçelik</Link>
              <Link to="/marka/beko-kombi" onClick={closeAllMenus}>▸ Beko</Link>
              <Link to="/marka/profilo-kombi" onClick={closeAllMenus}>▸ Profilo</Link>
              <Link to="/marka/remeha-kombi" onClick={closeAllMenus}>▸ Remeha</Link>
              <Link to="/marka/wolf-kombi" onClick={closeAllMenus}>▸ Wolf</Link>
            </div>
          </li>

          <li><Link to="/blog" onClick={closeAllMenus}>Blog</Link></li>
          <li><Link to="/iletisim" onClick={closeAllMenus}>İletişim</Link></li>

          {/* --- MOBİL MENÜ ALTI İLETİŞİM KISMI --- */}
          <div className="mobile-menu-footer">
            <span className="mm-subtitle">HIZLI İLETİŞİM</span>
            <a href="tel:03125810881" className="mm-phone">0312 581 08 81</a>
            <div className="mm-action-btns">
              <a href="https://wa.me/905325810881" className="mm-btn mm-wp">WhatsApp Destek</a>
            </div>
          </div>
        </ul>

        {/* SAĞ TARAF: BUTON VE MOBİL MENÜ */}
        <div className="nav-right">
          <a href="tel:03125810881" className="nav-call-btn"><span className="phone-icon">📞</span> 0312 581 08 81</a>
          
          <div className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
        </div>

      </div>
    </nav>
  );
}

export default Navbar;